import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

export const Breadcrumb = ({ items }) => {
  const { t, l } = useLang();
  return (
  <nav aria-label={t.common.breadcrumbAria} className="mb-8">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-plum/60">
      {items.map((item, i) => (
        <li key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-terracotta" aria-hidden="true" />}
          {item.to ? (
            <Link
              to={l(item.to)}
              data-testid={`breadcrumb-${i}`}
              className="hover:text-terracotta-deep transition-colors duration-200"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-ink font-medium" aria-current="page">
              {item.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
  );
};
